export enum ActionEvaluateEsocial {
  ApprovedEsocialFields = 'approvedEsocialFields',
  OverrideEsocialName = 'overrideEsocialName',
  NewEsocialFlow = 'newEsocialFlow',
  EsocialWithoutPis = 'esocialWithoutPis'
}